module.exports = __webpack_public_path__ + "img/bg-topup.eddda982.svg";